import { LitElement, html, css, unsafeCSS, property, customElement } from "lit-element";
import { DropdownModel } from "../../models/components/DropdownModel";
import { ReportEventCodeSetModel } from "../../models/report/ReportEventCodeSetModel";

import dropdownStyles from './dropdown.scss';

export default class Dropdown extends LitElement {
    @property({ type: Array })
    dropdownItems: DropdownModel[];

    @property({ type: String })
    selectedValue: string;

    @property({ type: String })
    dropdownLabel: String;

    @property({ type: Object })
    selectedItem: Object;

    private _selectedCallback;

    constructor(dropdownItems: DropdownModel[], selectedCallback, selectedValue: string, dropdownLabel: string) {
        super();

        this.dropdownItems = dropdownItems;
        this.selectedValue = selectedValue;
        this.dropdownLabel = dropdownLabel;

        this._selectedCallback = selectedCallback;
    }

    static get styles() {
        return [
            css`${unsafeCSS(dropdownStyles)}`
        ]
    }

    get control() {
        return this.shadowRoot.querySelector('select');
    }

    firstUpdated() {

    }

    selectChange(control) {
        let selectedIndex = control.selectedIndex;

        if (selectedIndex > -1) {
            this.selectedItem = control.options[selectedIndex];

            let selectedData = this.selectedItem["dropdownData"];
            let selectedValue = this.selectedItem["dropdownValue"];

            if (selectedData) {
                this._selectedCallback(selectedValue, selectedData);
            }
        }
    }

    createRenderRoot() {
        return this;
    }

    render() {
        let selectedDropdownModel = this.dropdownItems.find((dropdownModel) => dropdownModel.value == this.selectedValue);

        return [
            html`
            <label>${this.dropdownLabel}</label>
            <select class="form-control" @change=${(event) => this.selectChange(event.target)}>
                ${this.dropdownItems.map((dropDownModel) => html`<option 
                    ?selected=${this.selectedValue && dropDownModel.value == this.selectedValue ? true : false} 
                    .dropdownData="${dropDownModel.data}" 
                    .dropdownValue="${dropDownModel.value}" 
                    value='${dropDownModel.value}'>
                        ${dropDownModel.label}
                    </option>`)}
            </select>`
        ];
    }
}    